import type { LucideIcon } from 'lucide-react';

import { Card, CardContent, LoadingSpinner, Typography } from '@pesto/ui';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface CountTileProps {
  label: string;
  count: number | null | undefined;
  loading: boolean;
  error?: Error | null;
  to: string;
  icon: LucideIcon;
}

const formatCount = (count: number | null | undefined): string => {
  if (count === null || count === undefined) return '—';

  return new Intl.NumberFormat('en-US').format(count);
};

export const CountTile = ({ label, count, loading, error, to, icon: Icon }: CountTileProps) => (
  <Link to={to} className="block rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
    <Card className="hover:bg-muted/40 cursor-pointer transition-colors">
      <CardContent className="flex items-center justify-between gap-4 p-6">
        <div className="space-y-1">
          <div className="flex items-center gap-2">
            <Icon className="text-muted-foreground h-4 w-4" />
            <Typography variant="caption" className="text-muted-foreground uppercase tracking-wide">
              {label}
            </Typography>
          </div>
          {error ? (
            <Typography variant="body" className="text-destructive">
              Couldn't load
            </Typography>
          ) : loading ? (
            <LoadingSpinner />
          ) : (
            <Typography variant="headerLarge" className="text-3xl font-semibold">
              {formatCount(count)}
            </Typography>
          )}
        </div>
        <ChevronRight className="text-muted-foreground/60 h-5 w-5" />
      </CardContent>
    </Card>
  </Link>
);
